import data from '../data/strapi_single_collection.json';

const useSale = () => {
  const sale = data.strapiSingleCollection.data?.attributes?.SaleID || '';

  return { sale };
};

export default useSale;
